import React from 'react'
import { ReactNode } from 'react'
import { Box } from '@mui/material'

export const MainPageBox: React.FC<{ children: ReactNode }> = ({
  children
}) => {
  return (
    <Box
      sx={{
        pt: 8,
        pb: 6,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      {children}
    </Box>
  )
}
